module.exports = __webpack_public_path__ + "static/apple-icon-60x60-9b3adb4b10f7d026362e719297e8e7a8.png";